import {createAction} from '@reduxjs/toolkit';
import {resetSearchPageNumber} from './search.js';

export const setActiveResultId = createAction('SET_ACTIVE_RESULT_ID');

export const showFiltersPanel = createAction('SHOW_FILTERS_PANEL');

export const setResultsSortDirection = createAction(
  'SET_RESULTS_SORT_DIRECTION',
);

export const setResultsSortDirectionAndPageNumber = direction => dispatch => {
  dispatch(setResultsSortDirection(direction));
  dispatch(resetSearchPageNumber());
};

export const setScenesSortDirection = createAction('SET_SCENES_SORT_DIRECTION');
